'use client';

import {lazy, Suspense, useEffect, useState} from 'react';

const ErrorMonitorInit = lazy(() => import("@/components/error-monitor-init").then(mod => ({default: mod.ErrorMonitorInit})));

export function ErrorMonitorWrapper() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);

    if (!mounted) return null;

    return (
        <Suspense fallback={null}>
            <ErrorMonitorInit/>
        </Suspense>
    );
}
